var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitmentResultAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.135 0.783407C16.0151 0.701834 15.8761 0.652867 15.7316 0.641323C15.5871 0.62978 15.4421 0.656059 15.3108 0.717574L1.14413 7.38424C0.99932 7.45248 0.877228 7.56098 0.792455 7.69677C0.707682 7.83257 0.663815 7.9899 0.666101 8.14997C0.668386 8.31004 0.716727 8.46606 0.805342 8.59937C0.893958 8.73269 1.0191 8.83766 1.1658 8.90174L5.6658 10.8709V16.4726L10.5291 12.9992L14.4991 14.7359C14.6217 14.7896 14.7554 14.813 14.8889 14.8041C15.0224 14.7952 15.1518 14.7542 15.2662 14.6848C15.3805 14.6153 15.4764 14.5193 15.5459 14.4049C15.6153 14.2905 15.6561 14.1611 15.665 14.0276L16.4983 1.52757C16.5074 1.38268 16.4787 1.2379 16.415 1.10744C16.3513 0.976979 16.2548 0.865316 16.135 0.783407ZM14.08 12.7334L9.68913 10.8117L12.3325 5.63924L5.9583 9.18091L3.51496 8.11174L14.7408 2.82841L14.08 12.7334Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitmentResultAnnouncement);
export default __webpack_public_path__ + "static/media/recruitment_result_announcement.cfb485522a4562aea840328d60452ecb.svg";
export { ForwardRef as ReactComponent };